import axiosInstance from "../../../services/axiosInstance";

const instance = axiosInstance();

instance.defaults.baseURL += "/pursuit/task";

export async function createPursuitTask(variables) {
  const response = await instance.post(`/create`, variables);
  return response.data;
}

export async function getPursuitTask(task_id) {
  if (!task_id) return null;
  const response = await instance.get(`/get/${task_id}`);
  return response.data;
}

export async function getPursuitTasks(pursuit_id) {
  const response = await instance.get(`/get-all/${pursuit_id}`);
  return response.data;
}

export async function updatePursuitTaskKanban(data) {
  const updates = data.map((task) => ({
    id: task.id,
    pursuit_id: task.pursuit_id,
    status: task.status,
    index: task.kanban_row_index,
  }));
  const response = await instance.post(`/update-kanban`, updates);
  return response.data;
}

export async function updatePursuitTask(variables) {
  const response = await instance.patch("/update", variables);
  return response.data;
}

export async function deletePursuitTask(task_id) {
  const response = await instance.delete(`/delete/${task_id}`);
  return response.data;
}
